<mini-widget-icon-card
    iconImage="assets/icons/late.svg"
    [color]="statusColor"
    [isLoading]="loading"
    [clickable]="true"
    (click)="goToMissingInvoicesPage()"
>
    <div class="text-content">
        <strong>{{ 'WIDGET.MINI_MISSING_INVOICES.TITLE' | translate }}</strong>
        <h1 class="main-content" [coloredTextColor]="statusColor">
            <span class="kpi">
                {{ missingInvoicesCount }}
            </span>
        </h1>
        <p class="sub-content">{{ 'WIDGET.MINI_MISSING_INVOICES.MISSING_INVOICES' | translate | pluralize: missingInvoicesCount }}</p>
    </div>
</mini-widget-icon-card>
